import React from "react"

import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"

import { useProductConfiguratorConfigurationContext } from "../model/ProductConfiguratorConfigurationContext"

export const ProductConfiguratorErrorHint = React.memo(() => {
  const { errorMessages, isReady } =
    useProductConfiguratorConfigurationContext()

  if (!isReady) {
    return (
      <div className="product-configurator__error-hint product-configurator__error-hint--loading">
        <LoadingSpinner />
      </div>
    )
  }

  if (!errorMessages?.length) {
    return null
  }

  return (
    <div className="product-configurator__error-hint">
      {errorMessages.map(message => (
        <Hint.Root key={message} variant="danger" className="hint--banner">
          <Hint.Icon name={IconName.WARNING} />
          <Hint.Content>
            <Hint.Title>{message}</Hint.Title>
          </Hint.Content>
        </Hint.Root>
      ))}
    </div>
  )
})
